import $ from 'jquery';
import {isEmpty} from 'lodash';
import set from 'lodash/set';
import moment from 'moment';
import React, {
  CSSProperties,
  FunctionComponent,
  useEffect,
  useState,
} from 'react';
import QRCode from 'react-qr-code';
import {useDispatch} from 'react-redux';
import swal from 'sweetalert2';
import {InputLabelEditor} from '../../components/InputLabelEditor';
import {NotificationEditor} from '../../components/NotificationEditor';
import {getEndpoint, getHeaders} from '../../helpers/endpoint';
import {INotificationGet} from '../../types/notifications';
import { calculateBlogPostTargeting } from '../CreateNotification';
import {notificationsStatus} from '../NotificationsList';

const styles: Record<string, CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    margin: 16,
  },
  titleContainer: {
    display: 'flex',
    height: 43,
    backgroundColor: 'white',
    width: '100%',
    alignItems: 'center',
    fontSize: 18,
    paddingLeft: 16,
    justifyContent: 'space-between',
  },
  flex3: {
    flex: 3,
  },
  flex1: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
  },
  saveButton: {
    height: 48,
    width: 150,
    color: '#4054CC',
    borderRadius: 4,
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: '#4054CC',
    fontWeight: 'bold',
  },
  submitButton: {
    height: 48,
    width: 150,
    color: 'white',
    borderRadius: 4,
    backgroundColor: '#4054CC',
    fontWeight: 'bold',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    marginTop: 32,
  },
  disabledButton: {
    height: 48,
    width: 150,
    color: 'white',
    borderRadius: 4,
    backgroundColor: '#959DAF',
    fontWeight: 'bold',
    borderWidth: 0,
  },
  updatedAtContainer: {
    marginRight: 16,
  },
};

export const getBlogPostById = (
  blogPostId: string,
  onSuccess: (response: INotificationGet) => void,
) => {
  return (_dispatch, getState) => {
    return fetch(getEndpoint('getBlogPostById', blogPostId), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
        } else {
          onSuccess(data);
        }
      })
      .catch(error => {});
  };
};

export const updateBlogPost = (
  payload: INotificationGet,
  onSuccess?: (response: INotificationGet) => void,
) => {
  return (_dispatch, getState) => {
    return fetch(getEndpoint('updateBlogPost', payload.id), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          swal({
            title: `Oops...`,
            type: 'error',
            html: `Something went wrong !<br/>${data.message}<br/>`,
          });
        } else {
          // eslint-disable-next-line no-unused-expressions
          onSuccess?.(data);
        }
      })
      .catch(error => {});
  };
};

export const publishBlogPostById = (
  payload: INotificationGet,
  onSuccess?: (response: INotificationGet) => void,
) => {
  return (_dispatch, getState) => {
    return fetch(getEndpoint('publishBlogPost', payload.id), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          swal({
            title: `Oops...`,
            type: 'error',
            html: `Something went wrong !<br/>${data.message}<br/>`,
          });
        } else {
          // eslint-disable-next-line no-unused-expressions
          onSuccess?.(data);
        }
      })
      .catch(error => {});
  };
};

export const UpdateNotification: FunctionComponent = ({match}) => {
  const dispatch = useDispatch();
  const [errorForSubmit, setErrorForSubmit] = useState(false);
  const [targetNumber, setTargetNumber] = useState<number | undefined>();
  const [notification, setNotification] = useState<
    INotificationGet | undefined
  >(undefined);
  const onChange = (key: string, value: string | number | undefined) => {
    notification &&
      setNotification({
        ...set(notification, key, value !== '' ? value : undefined),
      });
  };

  const onSuccess = (response: INotificationGet, successModal?: boolean) => {
    if (successModal) {
      swal({
        title: `Sauvegardé`,
        type: 'success',
        html: ``,
      });
    }
    setNotification(response);
  };

  useEffect(() => {
    dispatch(getBlogPostById(match.params.notificationId, onSuccess));
  }, []);

  const onSave = (successModal?: boolean) => {
    if (notification) {
      dispatch(
        updateBlogPost(notification, response =>
          onSuccess(response, successModal),
        ),
      );
    }
  };

  const isSubmittable =
    !errorForSubmit &&
    notification?.name &&
    notification.scheduledDate &&
    ((notification.localization?.['fr-FR']?.title &&
      notification.localization['fr-FR'].description) ||
      (notification.localization?.['es-ES']?.title &&
        notification.localization['es-ES'].description) ||
      (notification.localization?.['en-GB']?.title &&
        notification.localization['en-GB'].description)) &&
    notification.targeting?.fields &&
    !isEmpty(notification.targeting.fields);

  const onClickValidate = () => {
    onSave();
    dispatch(
      calculateBlogPostTargeting(
        notification?.targeting || {fields: {}},
        response => setTargetNumber(response.totalCount),
      ),
    );
  };

  return (
    <div style={styles.container}>
      <div id="validateSendNotification" className="modal fade" role="dialog">
        <div className="modal-dialog">
          <div className="modal-body">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
                <h4 className="modal-title">
                  Valider l’envoi de cette notification ?
                </h4>
              </div>
              <div className="modal-body">
                <InputLabelEditor title="DATE / HEURE" />
                {moment(notification?.scheduledDate).isSameOrBefore(
                  moment(),
                ) ? (
                  <div>
                    <span style={{color: '#696773'}}>Immédiat: </span>
                    <span style={{color: 'red'}}>
                      <i
                        style={{marginRight: 8}}
                        className="fa fa-exclamation-triangle"
                      />
                      La notification partira dès la planification valider
                    </span>
                  </div>
                ) : (
                  <div>
                    <span style={{color: '#696773'}}>Différé: </span>
                    <span style={{fontWeight: 'bold'}}>
                      {moment(notification?.scheduledDate).format(
                        'DD/MM/YYYY HH:mm',
                      )}
                    </span>
                  </div>
                )}
                <div style={{marginTop: 32}}>
                  <InputLabelEditor title="RESULTAT CIBLAGE" />
                  <div style={{fontWeight: 'bold'}}>{`${
                    targetNumber !== undefined ? targetNumber : '-'
                  } Users`}</div>
                </div>
                <div
                  style={{
                    marginTop: 32,
                    display: 'flex',
                    alignItems: 'center',
                  }}>
                  <button
                    onClick={() => {
                      if (notification) {
                        dispatch(
                          publishBlogPostById(
                            notification,
                            (response: INotificationGet) => {
                              setNotification(response);
                              $('#validateSendNotification').modal('hide');
                            },
                          ),
                        );
                      }
                    }}
                    style={{...styles.submitButton, marginRight: 8}}>
                    Valider la planification
                  </button>
                  <button type="button" data-dismiss="modal" className="btn">
                    Annuler
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={styles.flex3}>
        <div style={styles.titleContainer}>
          <div>Update notification</div>
          <div style={{marginRight: 8}}>{`status: ${
            notification?.status && notificationsStatus[notification?.status]
          }`}</div>
        </div>
        {notification && (
          <NotificationEditor
            onChange={onChange}
            data={notification}
            setErrorForSubmit={setErrorForSubmit}
            calculateBlogPostTargeting={calculateBlogPostTargeting}
          />
        )}
        <div style={styles.buttonContainer}>
          <div style={styles.updatedAtContainer}>
            <div style={{color: '#696773'}}>Dernière sauvegarde :</div>
            <div>
              {!!notification?.updatedAt &&
                moment(notification?.updatedAt).format('DD/MM à HH:mm')}
            </div>
          </div>
          <button
            disabled={!notification?.name || errorForSubmit}
            style={
              !errorForSubmit && notification?.name
                ? styles.saveButton
                : styles.disabledButton
            }
            onClick={() => {
              onSave(true);
            }}>
            Sauvegarder
          </button>
          {notification?.status === 1 && (
            <div style={{marginLeft: 16, position: 'relative'}}>
              <span
                style={{
                  position: 'absolute',
                  marginLeft: 8,
                  color: 'red',
                  top: -16,
                  right: 0,
                }}>
                *
              </span>
              <button
                data-toggle="modal"
                data-target="#validateSendNotification"
                disabled={!isSubmittable}
                style={
                  isSubmittable ? styles.submitButton : styles.disabledButton
                }
                onClick={onClickValidate}>
                Planifier l'envoi
              </button>
            </div>
          )}
        </div>
      </div>
      <div style={{...styles.flex1, display: 'flex', justifyContent: 'center'}}>
        <QRCode
          value={`${process.env.DEEPLINK_URL}/app/notifs/notifications/${notification?.id}`}
        />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/UpdateNotification/index.tsx